var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none",
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8.2 10.18v4.42L1 7.8 8.2 1v4.04c2.66.2 8.8 1.43 8.8 8.36-2.24-2.73-6.67-3.17-8.8-3.22v0Z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgShare;